import axios from "axios";
// import md5 from "md5";

export const LOGIN_URL = "http://localhost:6001/api/admin/auth/login";
export const REGISTER_URL = "api/auth/register";
export const REQUEST_PASSWORD_URL = "api/auth/forgot-password";

export const ME_URL = "api/me";

export function login(email, password) {
	return axios.post(LOGIN_URL, { email, password });
}



// export function login=(email, password) {
// 	var encPass = md5(password)
// 	fetch("http://localhost:6001/api/admin/auth/login", {
// 		method: "post",
// 		headers: {
// 			'Content-Type': 'application/json',
// 			'Accept': 'application/json'
// 		},
// 		body: JSON.stringify({
// 			vEmail: email,
// 			vPassword: encPass
// 		}),
// 	}).then(response => response.json())
// 		.then(response => {
// 			if (response.code == 200) {
// 				console.log(response, ".......login response")
// 				const accessToken = response.accessToken
// 				localStorage.setItem("authToken", response.accessToken)
// 				const user = response
// 				// localStorage.setItem("user", (response))
// 				// var token = localStorage.getItem("authToken")
// 				// console.log(token, "token........")
// 				console.log(user, "user..........")
// 				return [200, accessToken]
// 			} else {
// 				console.log("login fail")
// 			}
// 		});

// }

// export function login(email, password) {
// 	let vMobileUUID = '123456';
// 	let data = { vEmail: email, vPassword: password, vMobileUUID: vMobileUUID };
// 	let headers = new Headers({
// 		accept: "application/json",
// 		"Content-Type": "application/json",
// 		nonce: "35A90B73C39D97",
// 		timestamp: "1615971782",
// 		token: "a656747cd0b3eb3f9e36025e6c732d695de0c710d5291ad4e6c2e4f7c02e004a",
// 	});
// 	let requestOptions = {
// 		method: 'POST',
// 		headers: headers,
// 		body: JSON.stringify(data)
// 	};
// 	return fetch(LOGIN_URL, requestOptions)
// 	// return axios.post(LOGIN_URL, data, { headers: headers });
// }

export function register(email, fullname, username, password) {
	return axios.post(REGISTER_URL, { email, fullname, username, password });
}

export function requestPassword(email) {
	return axios.post(REQUEST_PASSWORD_URL, { email });
}

export function getUserByToken() {
	// Authorization head should be fulfilled in interceptor.
	return axios.get(ME_URL);
}
